import api from "app/lib/api";
import endpoints from "static/endpoints";
import { BASE_URL } from "static/constants";
import { interpolate } from "utils/string";
import { formatDateRange } from "utils/date";

export const getQuickTextTemplates = async (query = {}) => {
  const { pagination = {}, filters, sorting, search } = query;

  const { pageSize, pageIndex: page } = pagination;

  let url = endpoints.quickTextTemplate.getTemplates;

  if (pageSize && page >= 0) {
    url += "?limit=" + pageSize;
    url += "&page=" + (page + 1);
  }

  if (filters && filters.length > 0) {
    let filterQuery = [];
    filters.forEach((filter) => {
      const { id, value } = filter;

      const filterValue = ["created_at"].includes(id)
        ? formatDateRange(value)
        : value;

      filterQuery.push(`${id}=${filterValue}`);
    });
    url += `&${filterQuery.join("&")}`;
  }

  if (search) {
    url += `&search=${search}`;
  }

  if (sorting?.length > 0) {
    const sortingQueries = sorting
      ?.map((sort) => {
        const { id, desc } = sort;
        const direction = desc ? "desc" : "asc";

        return `sort=${id}&order=${direction}`;
      })
      ?.filter(Boolean)
      ?.join("&");

    url += `&${sortingQueries}`;
  }

  const { data } = await api.get(url);
  return data;
};

export const addQuickTextTemplate = async (payload) => {
  const url = endpoints.quickTextTemplate.createTemplate;
  return await api.post(url, payload);
};

export const updateQuickTextTemplate = async (payload) => {
  const { templateId, title, description } = payload;

  if (!templateId) return;

  const url = `${BASE_URL}${interpolate(endpoints.quickTextTemplate.updateTemplate, { templateId })}`;
  return await api.put(url, { title, description });
};

export const deleteQuickTextTemplate = async (templateId) => {
  if (!templateId) return;

  const url = interpolate(endpoints.quickTextTemplate.deleteTemplate, {
    templateId,
  });
  return await api.delete(url);
};
